import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import './Home.scss';
import { environment } from '../../config/environment.ts';


const Home: FC = () => {
  const { isAuthenticated, isLoading, logout, getIdTokenClaims, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();

  const [hasCheckedToken, setHasCheckedToken] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      loginWithRedirect();
    }
  }, [isAuthenticated, loginWithRedirect]);

  // Define your custom payload type
  interface MyIdToken {
    enterpriseId?: string;
    [key: string]: any; // optional: allow other fields
  }

  useEffect(() => {

    // ID TOKEN
    const checkToken = async () => {
      try {
        const claims = await getIdTokenClaims();

        if (!claims) {
          throw new Error('No ID token found');
        }

        const decoded = jwtDecode<MyIdToken>(claims.__raw);
        const enterpriseId = decoded?.enterpriseId;

        if (enterpriseId) {
          // Redirect when enterprise ID is found
          window.location.href = `${environment?.league_redirection_url}`;
        } else {
          setError('Enterprise ID not found. Redirecting...');
          loginWithRedirect();
          setTimeout(() => {
            setError(null);
            logout({ logoutParams: { returnTo: window.location.origin } });
          }, 5000);
        }
      } catch (err) {
        console.error('Token error:', err);
      } finally {
        setHasCheckedToken(true);
      }
    };

    if (isAuthenticated && !hasCheckedToken) {
      checkToken();
    }
  }, [isAuthenticated, getIdTokenClaims, logout, navigate, hasCheckedToken]);

  // Show loading or nothing until the token is checked
  if (isLoading || (isAuthenticated && !hasCheckedToken)) {
    return <div>Loading...</div>;
  }


  // Show homepage with error if any
  return (
    <div className="loader-wrapper">
    <div className="spinner"></div>
    </div>
  );
};

export default Home;
